import { appInfo, applicationBase } from './environment.common';

export const environment = {
  appInfo,
  application: {
    ...applicationBase,
    angular: `${applicationBase.angular} DEV`,
  },
  config: {
    api: false,
    url: './assets/params/json/crud/',
  },
  apis:{
    auth:{
      url:"https://api-gw.optimus.uat.device.bolttech.asia/auth/redeem/openid-connect/token",
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body:{
        "grant_type":"client_credentials",
        "scope":"openid",
        "client_id": "uwevfc18ndxj",
        "client_secret": "NbE2P6i1sa0K0auSC8OyCtdjSG8yu47u"
      }
    },
    redeem:{
      url:"https://api-gw.optimus.uat.device.bolttech.asia/api/v1/redeem",
      headers:{
        'Content-Type': 'application/json',
      }
    }
  }
};